export default [
  {
    path: '/bank-profiles',
    name: 'bank-profiles',
    meta: { requiresAuth: true },
    component: () => import('@/pages/bank-profile/index.vue'),
    beforeEnter: async (to, from, next) => {
      next()
    }
  },
]
